import { SentryLink } from 'apollo-link-sentry';

const sentryLink = new SentryLink({
  breadcrumb: {
    includeError: true,
    includeQuery: true,
    includeVariables: true,
  },
});

export default sentryLink;
